import './tabThreeView.scss';
import pencilImage from '../../../assets/icons/pencil.png';
import { useNavigate } from 'react-router-dom';
import { IEmpInfoData } from 'types/listOfEmployees';
import moment from 'moment';
import { addComma } from 'constants/utils';
import DateSelector from 'common/date-selector/date-selector';
import { IPayByPayStart } from 'types/viewInfomation';

interface IProps {
  date: Date;
  minDate: Date | undefined;
  infoData: IEmpInfoData | null;
  handleSelectDate: (date: Date) => void;
  payData: IPayByPayStart;
  monthPayData: { [key: string]: string } | null;
  managerEditableEmpInfo: boolean;
}
const TabThreeView = ({
  date,
  minDate,
  infoData,
  handleSelectDate,
  payData,
  monthPayData,
  managerEditableEmpInfo,
}: IProps) => {
  const navigate = useNavigate();

  if (!monthPayData || !infoData) return null;
  console.log('monthPayData', monthPayData);
  // 수당 표시
  const allowanceList = [];
  if (monthPayData['THREE_CHECK'] === '1') allowanceList.push('추가야간휴일수당 50%자동 가산');
  if (monthPayData['WEEK_CHECK'] === '1') {
    if (monthPayData['WeekType'] === '1') {
      allowanceList.push('주휴수당 자동차감');
    } else {
      allowanceList.push(`주휴수당 일${monthPayData['WeekTime']}시간 차감`);
    }
  }
  if (monthPayData['REST_CHECK'] === '1') {
    if (monthPayData['RestType'] === '1') {
      allowanceList.push('휴게시간 자동가산');
    } else {
      allowanceList.push(`휴게시간 월${monthPayData['RestTime']}시간 가산`);
    }
  }
  // 소득 표시
  let insuaranceType = '없음';
  let insuaranceTypeDetail = '';
  if (monthPayData['insurance'] === '1') insuaranceType = '3.3%';
  if (monthPayData['insurance'] === '2') {
    insuaranceType = '4대보험';
    if (
      monthPayData['pension'] === '1' ||
      monthPayData['health'] === '1' ||
      monthPayData['employment'] === '1' ||
      monthPayData['pension'] === '1'
    ) {
      insuaranceType += '(';
      const insuaranceArr = [];
      if (monthPayData['pension'] === '1') insuaranceArr.push('국민연금');
      if (monthPayData['health'] === '1') insuaranceArr.push('건강보험');
      if (monthPayData['employment'] === '1') insuaranceArr.push('고용보험');
      if (monthPayData['accident'] === '1') insuaranceArr.push('산재보험');
      if (insuaranceArr.length > 0) insuaranceType += insuaranceArr.join(',');
      insuaranceType += ')';
    }
  }

  return (
    <div className="memberViewInfoTabThree">
      <div className="personalInfo">
        <div className="headingWithSettings">
          <div className="headingDark-type2">근로계약</div>
          {managerEditableEmpInfo && (
            <button
              className="settingsWrapper"
              onClick={() => {
                navigate('/work-schedule', {
                  state: {
                    empData: infoData,
                    formType: '근로계약',
                  },
                });
              }}>
              <img src={pencilImage} alt="" className="pencilImage" />
              수정
            </button>
          )}
        </div>

        <div className="label">날짜</div>
        <div className="value">
          <DateSelector
            onChange={handleSelectDate}
            value={date}
            minDate={minDate}
            placeholder="종료일 선택"
            isMonthPicker={true}
          />
        </div>
        <br />
        <div className="label">급여 정보</div>
        <div className="value">
          {payData ? (
            <>
              <div className="purple">
                {payData.PAY_TYPE === '2' ? '월급' : payData.PAY_TYPE === '1' ? '일급' : '시급'}
              </div>{' '}
              {addComma(payData.PAY.toString())}원
            </>
          ) : (
            <div className="value">급여정보 없음</div>
          )}
        </div>
        {payData.PAY_TYPE === '0' && (
          <>
            <br />
            <div className="label"></div>
            <div className="value">{allowanceList.join(' / ')}</div>
          </>
        )}
        <br />
        <div className="label">소득신고</div>
        <div className="value">
          {insuaranceType}
          {insuaranceTypeDetail}
        </div>
      </div>

      <div className="accountInfo">
        <div className="headingWithSettings">
          <div className="headingDark-type2">
            수습계약 <div className="green ">{infoData.probation === '1' ? 'on' : 'off'}</div>
          </div>

          {managerEditableEmpInfo && (
            <button
              className="settingsWrapper"
              onClick={() => {
                navigate('/work-schedule', {
                  state: {
                    empData: infoData,
                    formType: '수습계약',
                  },
                });
              }}>
              <img src={pencilImage} alt="" className="pencilImage" />
              수정
            </button>
          )}
        </div>
        {infoData.probation === '1' && (
          <>
            <div className="label">수습종료일</div>
            <div className="value">{moment(infoData.probationDATE).format('YYYY.MM.DD')}</div>
            <br />
            <div className="label">수습급여비율</div>
            <div className="value">{infoData.probationPercent}%</div>
          </>
        )}
      </div>
    </div>
  );
};

export default TabThreeView;
